import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import "@/assets/global.css";
import VueMask from "v-mask";
import VueApexCharts from "vue-apexcharts";

Vue.config.productionTip = false;
Vue.use(VueMask);
Vue.use(VueApexCharts);
Vue.component("apexChart", VueApexCharts);

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
